/*
  constants.js
*/

export const DEFAULT_NODE_COLOR = '#AAAAAA';
